import * as client_hooks from '../../../src/hooks.client.ts';


export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45'),
	() => import('./nodes/46'),
	() => import('./nodes/47'),
	() => import('./nodes/48'),
	() => import('./nodes/49'),
	() => import('./nodes/50'),
	() => import('./nodes/51'),
	() => import('./nodes/52'),
	() => import('./nodes/53'),
	() => import('./nodes/54'),
	() => import('./nodes/55'),
	() => import('./nodes/56'),
	() => import('./nodes/57'),
	() => import('./nodes/58'),
	() => import('./nodes/59'),
	() => import('./nodes/60'),
	() => import('./nodes/61'),
	() => import('./nodes/62'),
	() => import('./nodes/63'),
	() => import('./nodes/64'),
	() => import('./nodes/65'),
	() => import('./nodes/66'),
	() => import('./nodes/67'),
	() => import('./nodes/68'),
	() => import('./nodes/69'),
	() => import('./nodes/70'),
	() => import('./nodes/71'),
	() => import('./nodes/72'),
	() => import('./nodes/73'),
	() => import('./nodes/74'),
	() => import('./nodes/75'),
	() => import('./nodes/76'),
	() => import('./nodes/77'),
	() => import('./nodes/78'),
	() => import('./nodes/79'),
	() => import('./nodes/80'),
	() => import('./nodes/81'),
	() => import('./nodes/82'),
	() => import('./nodes/83'),
	() => import('./nodes/84'),
	() => import('./nodes/85'),
	() => import('./nodes/86'),
	() => import('./nodes/87'),
	() => import('./nodes/88'),
	() => import('./nodes/89'),
	() => import('./nodes/90'),
	() => import('./nodes/91'),
	() => import('./nodes/92'),
	() => import('./nodes/93'),
	() => import('./nodes/94'),
	() => import('./nodes/95'),
	() => import('./nodes/96'),
	() => import('./nodes/97'),
	() => import('./nodes/98'),
	() => import('./nodes/99'),
	() => import('./nodes/100'),
	() => import('./nodes/101'),
	() => import('./nodes/102'),
	() => import('./nodes/103'),
	() => import('./nodes/104'),
	() => import('./nodes/105'),
	() => import('./nodes/106'),
	() => import('./nodes/107'),
	() => import('./nodes/108')
];

export const server_loads = [];

export const dictionary = {
		"/": [20],
		"/(authed)/bundles": [21,[2,3]],
		"/(authed)/bundles/bundle/[id]": [22,[2,3]],
		"/(authed)/bundles/environment/[id]": [23,[2,3]],
		"/(authed)/bundles/project/[id]/diff": [24,[2,3]],
		"/(authed)/bundles/project/[id]/environments": [25,[2,3]],
		"/(authed)/bundles/project/[id]/sources": [26,[2,3]],
		"/(authed)/bundles/source/[id]": [27,[2,3]],
		"/(authed)/editor": [28,[2,4]],
		"/(authed)/editor/project": [81,[2,4]],
		"/(authed)/editor/project/[id]": [82,[2,4,11]],
		"/(authed)/editor/project/[id]/edit-sessions": [83,[2,4,11]],
		"/(authed)/editor/project/[id]/file/[nodeId]": [84,[2,4,11]],
		"/(authed)/editor/project/[id]/settings": [85,[2,4,11,12]],
		"/(authed)/editor/project/[id]/settings/usage": [86,[2,4,11,12]],
		"/(authed)/editor/project/[id]/structured-type/[stid]": [87,[2,4,11]],
		"/(authed)/editor/project/[id]/structured-value/[svid]": [88,[2,4,11]],
		"/(authed)/editor/project/[id]/tree/[...path]": [89,[2,4,11]],
		"/(authed)/editor/project/[id]/usage": [90,[2,4,11]],
		"/(authed)/editor/[type=es_or_t]/[id]/(tabs)": [31,[2,4,5,7]],
		"/(authed)/editor/[type=es_or_t]/[id]/(artifacts)/artifacts/[...path]": [30,[2,4,5,6]],
		"/(authed)/editor/[type=es_or_t]/[id]/(artifacts)/artifact/[...path]": [29,[2,4,5,6]],
		"/(authed)/editor/[type=es_or_t]/[id]/builds": [35,[2,4,5]],
		"/(authed)/editor/[type=es_or_t]/[id]/changes": [36,[2,4,5]],
		"/(authed)/editor/[type=es_or_t]/[id]/file/[nodeId]": [37,[2,4,5]],
		"/(authed)/editor/[type=es_or_t]/[id]/(tabs)/history": [32,[2,4,5,7,8]],
		"/(authed)/editor/[type=es_or_t]/[id]/(tabs)/history/[hid]": [33,[2,4,5,7,8]],
		"/(authed)/editor/[type=es_or_t]/[id]/inbox": [38,[2,4,5]],
		"/(authed)/editor/[type=es_or_t]/[id]/marketing": [39,[2,4,5]],
		"/(authed)/editor/[type=es_or_t]/[id]/(tabs)/overview": [34,[2,4,5,7]],
		"/(authed)/editor/[type=es_or_t]/[id]/sections/[section]": [40,[2,4,5]],
		"/(authed)/editor/[type=es_or_t]/[id]/settings": [41,[2,4,5,9]],
		"/(authed)/editor/[type=es_or_t]/[id]/settings/invitations": [42,[2,4,5,9]],
		"/(authed)/editor/[type=es_or_t]/[id]/settings/usage": [43,[2,4,5,9]],
		"/(authed)/editor/[type=es_or_t]/[id]/structured-type/[stid]": [44,[2,4,5]],
		"/(authed)/editor/[type=es_or_t]/[id]/structured-value/[svid]/[...prop_path=prop_path]/abilities": [46,[2,4,5,10]],
		"/(authed)/editor/[type=es_or_t]/[id]/structured-value/[svid]/[...prop_path=prop_path]/ability": [47,[2,4,5,10]],
		"/(authed)/editor/[type=es_or_t]/[id]/structured-value/[svid]/[...prop_path=prop_path]/changes": [48,[2,4,5,10]],
		"/(authed)/editor/[type=es_or_t]/[id]/structured-value/[svid]/[...prop_path=prop_path]/characterAppearance": [50,[2,4,5,10]],
		"/(authed)/editor/[type=es_or_t]/[id]/structured-value/[svid]/[...prop_path=prop_path]/characters": [51,[2,4,5,10]],
		"/(authed)/editor/[type=es_or_t]/[id]/structured-value/[svid]/[...prop_path=prop_path]/character": [49,[2,4,5,10]],
		"/(authed)/editor/[type=es_or_t]/[id]/structured-value/[svid]/[...prop_path=prop_path]/form": [52,[2,4,5,10]],
		"/(authed)/editor/[type=es_or_t]/[id]/structured-value/[svid]/[...prop_path=prop_path]/graph": [53,[2,4,5,10]],
		"/(authed)/editor/[type=es_or_t]/[id]/structured-value/[svid]/[...prop_path=prop_path]/items": [55,[2,4,5,10]],
		"/(authed)/editor/[type=es_or_t]/[id]/structured-value/[svid]/[...prop_path=prop_path]/item": [54,[2,4,5,10]],
		"/(authed)/editor/[type=es_or_t]/[id]/structured-value/[svid]/[...prop_path=prop_path]/location": [56,[2,4,5,10]],
		"/(authed)/editor/[type=es_or_t]/[id]/structured-value/[svid]/[...prop_path=prop_path]/maps": [57,[2,4,5,10]],
		"/(authed)/editor/[type=es_or_t]/[id]/structured-value/[svid]/[...prop_path=prop_path]/musicTracks": [59,[2,4,5,10]],
		"/(authed)/editor/[type=es_or_t]/[id]/structured-value/[svid]/[...prop_path=prop_path]/musicTrack": [58,[2,4,5,10]],
		"/(authed)/editor/[type=es_or_t]/[id]/structured-value/[svid]/[...prop_path=prop_path]/playbookTags": [62,[2,4,5,10]],
		"/(authed)/editor/[type=es_or_t]/[id]/structured-value/[svid]/[...prop_path=prop_path]/playbookTag": [61,[2,4,5,10]],
		"/(authed)/editor/[type=es_or_t]/[id]/structured-value/[svid]/[...prop_path=prop_path]/playbooks": [63,[2,4,5,10]],
		"/(authed)/editor/[type=es_or_t]/[id]/structured-value/[svid]/[...prop_path=prop_path]/playbook": [60,[2,4,5,10]],
		"/(authed)/editor/[type=es_or_t]/[id]/structured-value/[svid]/[...prop_path=prop_path]/playtestRuns": [64,[2,4,5,10]],
		"/(authed)/editor/[type=es_or_t]/[id]/structured-value/[svid]/[...prop_path=prop_path]/raw": [65,[2,4,5,10]],
		"/(authed)/editor/[type=es_or_t]/[id]/structured-value/[svid]/[...prop_path=prop_path]/secrets": [67,[2,4,5,10]],
		"/(authed)/editor/[type=es_or_t]/[id]/structured-value/[svid]/[...prop_path=prop_path]/secret": [66,[2,4,5,10]],
		"/(authed)/editor/[type=es_or_t]/[id]/structured-value/[svid]/[...prop_path=prop_path]/soundEffects": [69,[2,4,5,10]],
		"/(authed)/editor/[type=es_or_t]/[id]/structured-value/[svid]/[...prop_path=prop_path]/soundEffect": [68,[2,4,5,10]],
		"/(authed)/editor/[type=es_or_t]/[id]/structured-value/[svid]/[...prop_path=prop_path]/statuses": [71,[2,4,5,10]],
		"/(authed)/editor/[type=es_or_t]/[id]/structured-value/[svid]/[...prop_path=prop_path]/status": [70,[2,4,5,10]],
		"/(authed)/editor/[type=es_or_t]/[id]/structured-value/[svid]/[...prop_path=prop_path]/tags": [73,[2,4,5,10]],
		"/(authed)/editor/[type=es_or_t]/[id]/structured-value/[svid]/[...prop_path=prop_path]/tag": [72,[2,4,5,10]],
		"/(authed)/editor/[type=es_or_t]/[id]/structured-value/[svid]/[...prop_path=prop_path]/variables": [75,[2,4,5,10]],
		"/(authed)/editor/[type=es_or_t]/[id]/structured-value/[svid]/[...prop_path=prop_path]/variable": [74,[2,4,5,10]],
		"/(authed)/editor/[type=es_or_t]/[id]/structured-value/[svid]/[...prop_path=prop_path]/voiceEdit": [77,[2,4,5,10]],
		"/(authed)/editor/[type=es_or_t]/[id]/structured-value/[svid]/[...prop_path=prop_path]/voices": [78,[2,4,5,10]],
		"/(authed)/editor/[type=es_or_t]/[id]/structured-value/[svid]/[...prop_path=prop_path]/voice": [76,[2,4,5,10]],
		"/(authed)/editor/[type=es_or_t]/[id]/structured-value/[svid]/[...prop_path=prop_path]": [45,[2,4,5,10]],
		"/(authed)/editor/[type=es_or_t]/[id]/threads": [79,[2,4,5]],
		"/(authed)/editor/[type=es_or_t]/[id]/tree/[...path]": [80,[2,4,5]],
		"/(authed)/home": [91,[2,13]],
		"/(authed)/home/organization/[id]": [92,[2,13,14]],
		"/(authed)/home/organization/[id]/billing": [93,[2,13,14]],
		"/(authed)/home/organization/[id]/people": [94,[2,13,14,15]],
		"/(authed)/home/organization/[id]/people/invitations": [95,[2,13,14,15]],
		"/(authed)/home/organization/[id]/projects": [96,[2,13,14,16]],
		"/(authed)/home/organization/[id]/projects/archived": [97,[2,13,14,16]],
		"/(authed)/home/organization/[id]/usage": [98,[2,13,14]],
		"/(authed)/home/projects": [99,[2,13]],
		"/(authed)/home/user": [100,[2,13,17]],
		"/(authed)/home/user/billing": [101,[2,13,17]],
		"/(authed)/home/user/invitations": [102,[2,13,17]],
		"/(authed)/home/user/organizations": [103,[2,13,17,18]],
		"/(authed)/home/user/organizations/archived": [104,[2,13,17,18]],
		"/(authed)/home/user/usage": [105,[2,13,17]],
		"/invitation": [107],
		"/releases/[manifestBlobId]": [108,[19]],
		"/[logsignout=logsignout]": [106]
	};

export const hooks = {
	handleError: client_hooks.handleError || (({ error }) => { console.error(error) }),
	init: client_hooks.init,
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';